var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiSportCourt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 203,
    viewBox: "0 0 300 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1844_6672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 132.599L109.345 195.78L300 85.8898L190.215 22.3865L0 132.599Z",
    fill: "#FF7300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.345 195.781V202.328L300 92.437V85.8899L109.345 195.781Z",
    fill: "#BC4C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 132.599V139.146L109.345 202.328V195.781L0 132.599Z",
    fill: "#D85C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.345 192.006L109.05 191.833L6.59423 132.674L189.697 26.3926L189.995 26.5615L292.895 86.0352L292.012 86.5457L109.345 192.006ZM8.95464 132.674L109.345 190.639L290.527 86.0352L189.697 27.7554L8.95464 132.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.844 77.4419C215.457 79.2879 210.685 80.5407 206.298 82.1549C202.017 83.7495 196.66 84.6057 192.222 82.7912C181.677 78.4709 191.598 69.4967 197.234 64.3556L176.893 52.6282L49.4155 126.484L69.4456 138.043C76.1616 135.898 82.799 133.33 89.5582 131.413C93.6152 130.27 99.7499 129.842 103.304 132.646C106.446 135.133 105.806 138.852 103.261 141.46C101.25 143.522 99.0666 145.332 97.1343 147.488C95.8382 148.934 94.5657 150.387 93.2461 151.809L116.041 164.954L243.798 91.2902L219.844 77.4419Z",
    fill: "#94C628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.041 165.637L115.747 165.468L48.2372 126.484L176.893 51.929L244.98 91.2901L116.041 165.637ZM50.5937 126.465L116.041 164.259L242.62 91.2901L176.893 53.2957L50.5937 126.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.886 119.812C135.486 119.812 127.034 114.631 127.034 108.265C127.034 101.898 135.494 96.718 145.886 96.718C156.278 96.718 164.738 101.898 164.738 108.265C164.738 114.631 156.286 119.812 145.886 119.812ZM145.886 97.9002C136.138 97.9002 128.212 102.55 128.212 108.265C128.212 113.979 136.146 118.629 145.886 118.629C155.626 118.629 163.56 113.979 163.56 108.265C163.56 102.55 155.634 97.9002 145.886 97.9002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9773 119.607C38.2536 119.607 20.4032 124.52 7.58395 132.415C7.91529 132.653 8.20804 132.94 8.45192 133.267C21.0473 125.597 38.5913 120.825 57.9773 120.825C96.2152 120.825 127.325 139.37 127.325 162.165C127.325 173.241 119.965 183.307 108.025 190.738C108.265 191.052 108.508 191.366 108.775 191.657C120.998 184.002 128.538 173.61 128.538 162.165C128.538 138.699 96.8868 119.607 57.9773 119.607Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.289 86.1138C291.026 85.8389 290.778 85.5483 290.531 85.2615C277.963 92.8848 260.454 97.6213 241.143 97.6213C202.905 97.6213 171.796 79.0718 171.796 56.2768C171.796 45.2484 179.093 35.2216 190.942 27.7987C190.574 27.5852 190.229 27.3366 189.909 27.0564C177.942 34.6875 170.578 44.9696 170.578 56.2768C170.578 79.7434 202.233 98.8349 241.143 98.8349C260.78 98.8349 278.536 93.9727 291.34 86.1492C291.322 86.1387 291.305 86.1269 291.289 86.1138V86.1138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1601 79.9506L97.5684 80.9741L199.345 139.806L199.937 138.782L98.1601 79.9506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.384 84.2797C191.857 84.2797 186.551 80.9924 186.551 76.9471C186.551 72.9018 191.857 69.6145 198.384 69.6145C204.912 69.6145 210.214 72.9057 210.214 76.9471C210.214 80.9885 204.908 84.2797 198.384 84.2797ZM198.384 70.7967C192.493 70.7967 187.733 73.5459 187.733 76.9471C187.733 80.3483 192.509 83.1014 198.384 83.1014C204.26 83.1014 209.036 80.3522 209.036 76.9471C209.036 73.542 204.256 70.7967 198.384 70.7967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 71.8481L189.415 72.8755L205.925 82.2734L206.51 81.246L190 71.8481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.55 144.7C88.0265 144.7 82.7165 141.413 82.7165 137.367C82.7165 133.322 88.0265 130.035 94.55 130.035C101.074 130.035 106.383 133.326 106.383 137.367C106.383 141.409 101.074 144.7 94.55 144.7ZM94.55 131.217C88.6588 131.217 83.8987 133.966 83.8987 137.367C83.8987 140.768 88.6784 143.518 94.55 143.518C100.422 143.518 105.201 140.768 105.201 137.367C105.201 133.966 100.425 131.217 94.55 131.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1784 132.268L85.5936 133.295L102.103 142.693L102.688 141.666L86.1784 132.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.141 72.7918L188.185 73.0864L217.798 43.1355L218.635 43.9681L190.141 72.7918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.292 65.3498L206.046 81.2019L206.402 82.3293L256.648 66.4772L256.292 65.3498Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3041 149.032L34.9545 147.905L86.7304 131.916L86.0627 133.361L35.3041 149.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.964 141.788L73.8577 170.68L74.705 171.504L102.811 142.612L101.964 141.788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5155 99.465L94.9245 100.489L161.552 138.956L162.143 137.933L95.5155 99.465Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.302 77.5516L132.71 78.5754L199.338 117.043L199.929 116.019L133.302 77.5516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.623 55.4049H233.551V13.3534C233.551 13.3534 225.457 9.88549 224.047 9.39062V11.5547C226.215 12.3991 228.995 13.6755 231.623 14.8184V55.4049Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.551 55.5149C233.551 55.833 233.119 56.0922 232.585 56.0922C232.051 56.0922 231.623 55.833 231.623 55.5149C231.623 55.1967 232.055 54.9336 232.585 54.9336C233.115 54.9336 233.551 55.1928 233.551 55.5149Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.272 15.4115L232.271 24.0519V8.74264L217.272 1.15869V15.4115Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.353 15.8435L231.348 24.48V9.17462L216.353 0.53418V15.8435Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.348 24.4799L232.271 24.0518V8.63647L231.348 9.17454V24.4799Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.353 0.534136L217.272 0L232.271 8.63651L231.348 9.17458L216.353 0.534136Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.746 18.7497L219.938 14.2606V6.28394L227.734 10.773L227.746 18.7497ZM220.249 14.0918L227.452 18.2392V10.9262L220.249 6.7788V14.0918Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.68 22.9796L217.126 15.1718V2.04614L230.68 9.85396V22.9796ZM217.421 14.9989L230.382 22.4611V10.0228L217.421 2.56064V14.9989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.689 15.1404H220.19V20.4385H220.689V15.1404Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.958 15.6056L217.464 15.6777L218.242 20.994L218.735 20.9218L217.958 15.6056Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.944 15.7965L222.167 21.1128L222.656 21.1844L223.434 15.8681L222.944 15.7965Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.441 25.3753C218.305 25.3753 216.632 24.2913 216.632 22.9089C216.632 21.5264 218.305 20.4385 220.441 20.4385C222.578 20.4385 224.259 21.5225 224.259 22.9089C224.259 24.2953 222.574 25.3753 220.441 25.3753ZM220.441 20.9373C218.584 20.9373 217.13 21.8013 217.13 22.901C217.13 24.0007 218.584 24.8647 220.441 24.8647C222.299 24.8647 223.748 23.9968 223.748 22.901C223.748 21.8052 222.295 20.9373 220.441 20.9373Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.429 23.6983C218.104 23.6983 216.278 22.52 216.278 21.004C216.278 19.488 218.104 18.3137 220.429 18.3137C222.754 18.3137 224.581 19.492 224.581 21.004C224.581 22.5161 222.758 23.6983 220.429 23.6983ZM220.429 18.8557C218.407 18.8557 216.82 19.7983 216.82 21.004C216.82 22.2098 218.391 23.1563 220.429 23.1563C222.468 23.1563 224.039 22.2098 224.039 21.004C224.039 19.7983 222.452 18.8518 220.429 18.8518V18.8557Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.429 22.0882C217.967 22.0882 216.035 20.8353 216.035 19.2368C216.035 17.6384 217.967 16.3855 220.429 16.3855C222.892 16.3855 224.828 17.6384 224.828 19.2368C224.828 20.8353 222.896 22.0882 220.429 22.0882ZM220.429 16.9589C218.289 16.9589 216.612 17.9604 216.612 19.2368C216.612 20.5133 218.289 21.5148 220.429 21.5148C222.57 21.5148 224.259 20.5133 224.259 19.2447C224.259 17.9761 222.574 16.9589 220.429 16.9589Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.242 18.0772L215.752 18.1682L216.636 22.9334L217.126 22.8424L216.242 18.0772Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.259 22.9521L223.768 22.8618C224.129 20.9491 224.667 18.0389 224.687 17.8503H225.186C225.17 17.9957 224.651 20.7056 224.259 22.9521Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.269 24.7353L217.943 20.2187L218.438 20.1833L218.764 24.6999L218.269 24.7353Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.55 20.0565L222.221 24.573L222.715 24.6089L223.043 20.0924L222.55 20.0565Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.689 20.686H220.19V25.128H220.689V20.686Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.441 20.8432C217.763 20.8432 215.669 19.5354 215.669 17.8662C215.669 16.197 217.763 14.8892 220.441 14.8892C223.12 14.8892 225.213 16.197 225.213 17.8662C225.213 19.5354 223.116 20.8432 220.441 20.8432ZM220.441 15.4704C218.167 15.4704 216.247 16.5662 216.247 17.8662C216.247 19.1662 218.167 20.2619 220.441 20.2619C222.715 20.2619 224.651 19.1662 224.651 17.8662C224.651 16.5662 222.711 15.4704 220.441 15.4704Z",
    fill: "#D6403C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.301 68.8644V51.8584L211.777 38.8545V55.7348L211.133 55.4913V37.6252L234.941 51.3714V69.1432L234.301 68.8644Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.543 50.7822L219.903 50.3894L211.133 55.4598L211.824 55.8525C212.115 55.77 220.543 50.7822 220.543 50.7822Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.385 63.5818C243.385 63.5818 234.592 68.7307 234.301 68.8682L234.882 69.1941L243.798 64.1434L243.385 63.5818Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.083 64.4105C243.083 64.2926 240.998 52.7262 240.766 51.1749C240.534 49.6235 240.102 49.6039 239.674 49.8238L234.47 52.4552V51.6108C234.588 51.5401 238.72 49.4507 239.69 48.9558C240.868 48.351 241.218 49.6353 241.371 50.6564C241.606 52.2274 243.727 63.676 243.782 64.1434L243.083 64.4105Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.829 51.0335C219.829 50.9196 217.374 38.9644 217.142 37.4169C216.91 35.8695 216.478 35.8459 216.046 36.062C214.919 36.6354 211.161 38.5127 211.133 38.5323V37.7036C211.251 37.6329 215.104 35.7163 216.074 35.2215C217.252 34.6166 217.602 35.9009 217.755 36.9221C217.99 38.4931 220.504 50.3265 220.539 50.7978L219.829 51.0335Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.19 49.9895L219.815 50.6433L243.058 64.0032L243.433 63.3494L220.19 49.9895Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.824 47.9982L219.698 48.2158L234.418 56.7245L234.544 56.5069L219.824 47.9982Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.722 55.1456L219.404 46.4463L219.53 46.2263L234.847 54.9257L234.722 55.1456Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.035 44.373L218.909 44.5906L234.421 53.5573L234.547 53.3397L219.035 44.373Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.269 51.1436L212.708 37.5231L212.834 37.3071L236.395 50.9237L236.269 51.1436Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.386 36.5863L214.26 36.804L237.817 50.4211L237.943 50.2034L214.386 36.5863Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.752 35.8622L215.627 36.0798L239.184 49.6969L239.309 49.4793L215.752 35.8622Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.562 49.1209L216.687 35.3198L216.812 35.0999L240.691 48.901L240.562 49.1209Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.457 51.3203H236.206V68.0081H236.457V51.3203Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.801 50.6487H237.549V67.3404H237.801V50.6487Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.175 49.6826H238.924V66.3705H239.175V49.6826Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.518 49.3369H240.267V65.7027H240.518V49.3369Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.889 38.9487H212.637V54.6429H212.889V38.9487Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.228 39.8442H213.977V53.9714H214.228V39.8442Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.603 40.6887H215.351V53.0053H215.603V40.6887Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.946 41.3523H216.694V52.3335H216.946V41.3523Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.344 41.4546H218.093V51.6817H218.344V41.4546Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.87 55.1692H241.618V64.7836H241.87V55.1692Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.069 39.0586L212.952 38.8387C213.136 38.7405 217.46 36.4508 218.006 36.2387C218.221 36.1837 218.446 36.1781 218.664 36.2223C218.881 36.2666 219.086 36.3594 219.263 36.494L219.114 36.6943C218.97 36.5864 218.805 36.5109 218.629 36.4729C218.454 36.4349 218.272 36.4354 218.096 36.4743C217.582 36.6825 213.113 39.035 213.069 39.0586Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.499 39.9542L214.381 39.7304C214.566 39.6322 218.886 37.3464 219.432 37.1343C219.648 37.0784 219.873 37.0724 220.092 37.1166C220.31 37.1608 220.516 37.2542 220.693 37.3896L220.543 37.5899C220.4 37.4808 220.234 37.4045 220.057 37.3665C219.881 37.3285 219.698 37.3297 219.522 37.37C218.992 37.5742 214.542 39.9307 214.499 39.9542Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.987 40.7435L215.87 40.5197C216.054 40.4215 220.378 38.1357 220.924 37.9236C221.14 37.8659 221.366 37.859 221.585 37.9033C221.803 37.9476 222.009 38.0419 222.185 38.1789L222.032 38.3792C221.889 38.2706 221.723 38.1947 221.548 38.1567C221.372 38.1187 221.19 38.1196 221.015 38.1593C220.48 38.3635 216.035 40.72 215.987 40.7435Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.448 41.5958L217.331 41.372C217.511 41.2738 221.835 38.988 222.381 38.7759C222.597 38.7182 222.823 38.7113 223.042 38.7556C223.26 38.7998 223.466 38.8942 223.642 39.0312L223.489 39.2315C223.346 39.1219 223.181 39.0454 223.005 39.0073C222.829 38.9693 222.647 38.9708 222.472 39.0115C221.941 39.2158 217.492 41.5723 217.448 41.5958Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.682 42.3342L218.564 42.1103C218.748 42.0122 223.073 39.7224 223.619 39.5143C223.833 39.457 224.058 39.4499 224.276 39.4935C224.494 39.5371 224.699 39.6302 224.875 39.7656L224.726 39.9699C224.583 39.8611 224.418 39.7847 224.242 39.7461C224.066 39.7074 223.884 39.7074 223.709 39.746C223.175 39.9542 218.725 42.3106 218.682 42.3342Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.99 43.0884L219.872 42.8684C220.056 42.7702 224.38 40.4805 224.926 40.2724C225.141 40.2163 225.366 40.2098 225.584 40.2533C225.801 40.2968 226.006 40.3893 226.183 40.5237L226.034 40.724C225.89 40.6161 225.725 40.5406 225.549 40.5027C225.374 40.4647 225.192 40.4652 225.017 40.5041C224.483 40.7122 220.033 43.0648 219.99 43.0884Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.321 43.8423L221.203 43.6223C221.388 43.5241 225.712 41.2344 226.258 41.0223C226.473 40.9668 226.698 40.9609 226.916 41.0051C227.133 41.0494 227.338 41.1426 227.515 41.2776L227.365 41.4779C227.222 41.3691 227.057 41.293 226.881 41.255C226.705 41.217 226.523 41.218 226.348 41.258C225.83 41.4622 221.364 43.8187 221.321 43.8423Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.782 44.6947L222.664 44.4748C222.849 44.3766 227.173 42.0869 227.719 41.8748C227.934 41.8183 228.16 41.812 228.379 41.8562C228.597 41.9005 228.803 41.9941 228.98 42.1301L228.826 42.3304C228.683 42.2218 228.518 42.1458 228.342 42.1078C228.166 42.0698 227.984 42.0707 227.809 42.1104C227.279 42.3147 222.829 44.6711 222.782 44.6947Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.113 45.4643L223.996 45.2404C224.18 45.1422 228.504 42.8565 229.05 42.6444C229.266 42.5885 229.491 42.5821 229.709 42.6257C229.928 42.6692 230.133 42.7615 230.311 42.8957L230.158 43.1C230.014 42.9916 229.849 42.9158 229.673 42.8778C229.498 42.8398 229.316 42.8406 229.141 42.88C228.61 43.0843 224.161 45.4407 224.113 45.4643Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.437 46.2184L225.319 45.9985C225.504 45.9003 229.828 43.6106 230.374 43.4024C230.589 43.3466 230.815 43.3402 231.033 43.3837C231.251 43.4273 231.457 43.5196 231.634 43.6538L231.481 43.8541C231.337 43.7467 231.172 43.6717 230.996 43.6344C230.821 43.5971 230.639 43.5984 230.464 43.6381C229.918 43.8423 225.468 46.1949 225.437 46.2184Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.753 46.9726L226.635 46.7526C226.819 46.6545 231.144 44.3647 231.689 44.1527C231.905 44.0974 232.131 44.0916 232.349 44.1358C232.567 44.18 232.773 44.2731 232.95 44.4079L232.797 44.6082C232.654 44.4997 232.488 44.4237 232.313 44.3857C232.137 44.3477 231.955 44.3486 231.78 44.3883C231.25 44.5965 226.8 46.949 226.753 46.9726Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.218 47.8249L228.1 47.6049C228.28 47.5068 232.605 45.217 233.151 45.005C233.366 44.9497 233.592 44.9439 233.81 44.9881C234.028 45.0323 234.234 45.1254 234.411 45.2602L234.262 45.4605C234.118 45.3523 233.952 45.2767 233.776 45.2387C233.599 45.2007 233.417 45.2014 233.241 45.2406C232.711 45.4488 228.261 47.8013 228.218 47.8249Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.388 48.5002L229.27 48.2764C229.455 48.1782 233.779 45.8924 234.325 45.6803C234.54 45.6242 234.764 45.6177 234.982 45.6613C235.2 45.7048 235.405 45.7973 235.582 45.9317L235.432 46.1359C235.29 46.0259 235.125 45.949 234.949 45.911C234.773 45.8729 234.59 45.8746 234.415 45.916C233.881 46.1202 229.431 48.4767 229.388 48.5002Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.696 49.2543L230.578 49.0344C230.763 48.9362 235.087 46.6465 235.633 46.4384C235.847 46.3811 236.072 46.374 236.29 46.4175C236.508 46.4611 236.713 46.5543 236.889 46.6897L236.74 46.89C236.597 46.7821 236.431 46.7066 236.256 46.6687C236.08 46.6307 235.898 46.6312 235.723 46.6701C235.189 46.8782 230.739 49.2308 230.696 49.2543Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.027 50.0084L231.909 49.7885C232.094 49.6903 236.418 47.4005 236.964 47.1885C237.179 47.1326 237.404 47.1266 237.622 47.1708C237.84 47.2151 238.045 47.3084 238.221 47.4438L238.072 47.6441C237.928 47.5357 237.763 47.4599 237.587 47.4219C237.412 47.3839 237.23 47.3847 237.054 47.4241C236.52 47.6283 232.07 49.9848 232.027 50.0084Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.488 50.8608L233.37 50.6408C233.555 50.5426 237.879 48.2529 238.425 48.0408C238.641 47.9856 238.866 47.9798 239.085 48.024C239.303 48.0682 239.509 48.1612 239.686 48.2961L239.533 48.4964C239.389 48.3881 239.224 48.3123 239.048 48.2743C238.873 48.2363 238.691 48.2371 238.515 48.2765C238.005 48.4807 233.535 50.8372 233.488 50.8608Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.172 62.0312L234.717 66.811L234.84 67.0298L243.295 62.2501L243.172 62.0312Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.871 65.0391L234.745 64.8191L242.737 60.2947L242.859 60.5107L234.871 65.0391Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.389 58.6323L234.722 62.9629L234.846 63.1817L242.513 58.8511L242.389 58.6323Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.092 57.0164L234.619 61.2415L234.742 61.4603L242.216 57.2352L242.092 57.0164Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.933 55.3212L234.719 59.3994L234.842 59.6182L242.057 55.54L241.933 55.3212Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.686 53.6549L234.724 57.5876L234.847 57.8065L241.81 53.8738L241.686 53.6549Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.151 52.1063L234.477 55.8792L234.601 56.098L241.275 52.3252L241.151 52.1063Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.868 50.4593L234.621 53.9905L234.745 54.2093L240.992 50.6781L240.868 50.4593Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.64 53.6218L211.518 53.4019L219.966 48.6143L220.092 48.8342L211.64 53.6218Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.538 46.8813L211.541 51.4021L211.665 51.6209L219.662 47.1001L219.538 46.8813Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.64 49.761L211.518 49.541L219.18 45.2012L219.302 45.4211L211.64 49.761Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.542 48.0526L211.416 47.8327L218.886 43.5989L219.012 43.8188L211.542 48.0526Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.364 42.1147L211.513 45.988L211.636 46.2069L218.488 42.3335L218.364 42.1147Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.686 41.2441L211.513 44.1685L211.637 44.3873L216.81 41.463L216.686 41.2441Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.396 42.6876L211.274 42.4677L214.998 40.3586L215.119 40.5786L211.396 42.6876Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.386 39.4753L211.42 40.5859L211.544 40.8048L213.51 39.6941L213.386 39.4753Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.899 50.5306L232.652 50.5759L234.089 58.4061L234.336 58.3608L232.899 50.5306Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.946 49.4361L230.699 49.4814L232.136 57.3116L232.383 57.2663L230.946 49.4361Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.025 48.4131L228.778 48.4585L230.215 56.2887L230.462 56.2433L229.025 48.4131Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.457 55.2596L227.02 47.4282L227.267 47.3811L228.705 55.2125L228.457 55.2596Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.658 46.215L224.412 46.2603L225.845 54.062L226.091 54.0168L224.658 46.215Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.807 45.2369L223.559 45.2822L224.996 53.1124L225.244 53.0671L223.807 45.2369Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.312 52.3612L221.875 44.5298L222.122 44.4827L223.56 52.314L223.312 52.3612Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.643 51.1788L220.206 43.3474L220.453 43.3042L221.89 51.1317L221.643 51.1788Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0044 153.497V137.081L67.2619 124.528V140.945L66.6414 140.588V123.342L89.6249 136.609V153.764L89.0044 153.497Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0044 153.344L80.3757 158.297L58.7943 145.831L67.2619 140.945L66.6414 140.588L57.3411 145.894L80.2697 159.133L89.6249 153.765L89.0044 153.344Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7096 158.701L79.9044 158.599C79.9044 158.493 81.279 148.887 81.6836 145.478C82.0763 142.171 82.7401 140.454 83.9065 139.747C84.3778 139.461 88.7334 136.684 88.8394 136.605L89.4482 137.092C89.3461 137.151 84.8138 140.128 84.3425 140.427C83.7219 140.82 82.9561 141.723 82.5044 145.56C82.0842 148.985 80.7213 158.595 80.7096 158.701Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1462 146.043L57.3411 145.941C57.3411 145.835 58.7157 136.224 59.1203 132.819C59.513 129.508 60.0589 127.663 61.2254 126.956C61.7006 126.669 66.5353 123.401 66.6414 123.342L67.3758 123.825C67.2737 123.884 62.1366 127.36 61.6456 127.647C61.029 128.02 60.377 129.076 59.9254 132.914C59.5209 136.323 58.1619 145.937 58.1462 146.043Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5485 156.906L57.8085 143.761L57.9302 143.549L80.6703 156.694L80.5485 156.906Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9963 155.151L58.2562 142.006L58.378 141.793L81.118 154.939L80.9963 155.151Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6692 139.949L58.5474 140.16L81.2883 153.306L81.4102 153.095L58.6692 139.949Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6441 137.834L59.5223 138.046L81.927 150.922L82.0487 150.71L59.6441 137.834Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.118 136.313L58.9961 136.524L81.2917 149.412L81.4135 149.201L59.118 136.313Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7386 147.653L59.2931 134.677L59.4109 134.465L81.8603 147.441L81.7386 147.653Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4109 132.448L59.289 132.659L82.03 145.804L82.1519 145.593L59.4109 132.448Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8589 130.691L59.737 130.901L82.478 144.047L82.5998 143.836L59.8589 130.691Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0425 142.265L60.3024 129.12L60.4242 128.907L83.1642 142.053L83.0425 142.265Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9104 140.694L61.1665 127.545L61.2882 127.336L84.0322 140.482L83.9104 140.694Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7609 126.295L62.639 126.505L85.38 139.651L85.5018 139.44L62.7609 126.295Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7854 138.659L64.0414 125.51L64.1631 125.302L86.9071 138.447L86.7854 138.659Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.2071 137.717L65.467 124.572L65.5849 124.36L88.3289 137.509L88.2071 137.717Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5758 146.887L59.3323 146.852C59.3323 146.742 60.8405 135.875 61.2647 132.619C61.6574 129.528 62.4233 128.856 63.032 128.318L63.1734 128.189C63.8097 127.608 68.3027 124.76 68.4951 124.654L68.6247 124.858C68.5776 124.89 63.9589 127.82 63.3384 128.393L63.193 128.523C62.5843 129.061 61.897 129.673 61.5042 132.674C61.0801 135.922 59.5915 146.793 59.5758 146.887Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0958 147.7L60.8523 147.669C60.8523 147.559 62.3604 136.672 62.7846 133.436C63.1773 130.345 63.9432 129.673 64.5519 129.135L64.6933 129.006C65.3296 128.424 69.8226 125.577 70.0151 125.471L70.1447 125.675C70.0975 125.707 65.4788 128.633 64.8583 129.21L64.713 129.34C64.1042 129.878 63.4169 130.49 63.0242 133.491C62.6 136.723 61.1075 147.594 61.0958 147.7Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.6353 148.549L62.3958 148.514C62.3958 148.404 63.9 137.536 64.3241 134.28C64.7169 131.189 65.5024 130.518 66.0954 129.98L66.2368 129.85C66.8731 129.269 71.3661 126.421 71.5546 126.315L71.6842 126.52C71.6371 126.551 67.0223 129.481 66.4018 130.054L66.2565 130.184C65.6477 130.722 64.9565 131.335 64.5637 134.335C64.1435 137.568 62.651 148.459 62.6353 148.549Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1553 149.346L63.9157 149.315C63.9157 149.205 65.4199 138.318 65.8441 135.081C66.2368 131.987 67.0223 131.319 67.6154 130.761L67.7568 130.636C68.393 130.054 72.8625 127.207 73.0746 127.101L73.2042 127.305C73.157 127.336 68.5383 130.262 67.9178 130.84L67.7764 130.969C67.1676 131.507 66.4764 132.116 66.0837 135.121C65.6595 138.369 64.171 149.244 64.1553 149.346Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6477 150.446L65.4042 150.41C65.4042 150.3 66.9124 139.413 67.3365 136.177C67.7293 133.086 68.5148 132.415 69.1039 131.857L69.2453 131.727C69.8815 131.146 74.3746 128.299 74.567 128.193L74.6966 128.397C74.6495 128.428 70.0308 131.358 69.4102 131.932L69.2649 132.061C68.6562 132.599 67.9688 133.212 67.5761 136.213C67.1598 139.464 65.6595 150.336 65.6477 150.446Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1598 151.243L66.9202 151.212C66.9202 151.102 68.4284 140.215 68.8486 136.979C69.2413 133.888 70.0268 133.216 70.6199 132.678L70.7613 132.548C71.3975 131.967 75.8906 129.12 76.0791 129.014L76.2087 129.218C76.1655 129.249 71.5468 132.175 70.9262 132.753L70.7809 132.882C70.1722 133.42 69.4809 134.033 69.0921 137.034C68.6719 140.266 67.1794 151.133 67.1598 151.243Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.7072 152.087L68.4676 152.056C68.4676 151.946 69.9719 141.059 70.396 137.823C70.7888 134.732 71.5546 134.06 72.1634 133.522L72.3087 133.393C72.9449 132.811 77.4144 129.964 77.6265 129.858L77.7561 130.062C77.709 130.094 73.0903 133.02 72.4697 133.597L72.3283 133.726C71.7196 134.265 71.0283 134.877 70.6356 137.878C70.2114 141.11 68.7308 151.993 68.7072 152.087Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2271 152.889L69.9836 152.857C69.9836 152.747 71.4918 141.86 71.916 138.624C72.3087 135.533 73.0746 134.862 73.6833 134.304C73.7344 134.265 73.7815 134.221 73.8286 134.178C74.461 133.597 78.954 130.75 79.1464 130.644L79.276 130.848C79.2289 130.879 74.6102 133.805 73.9897 134.383L73.8443 134.512C73.2356 135.05 72.5483 135.659 72.1555 138.663C71.7314 141.911 70.2429 152.779 70.2271 152.889Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7196 153.8L71.4761 153.765C71.4761 153.659 72.9842 142.787 73.4084 139.535C73.8011 136.44 74.5866 135.769 75.1758 135.215L75.3171 135.089C75.9534 134.508 80.4464 131.657 80.6389 131.555L80.7685 131.759C80.7213 131.786 76.1026 134.716 75.4821 135.294L75.3368 135.423C74.728 135.965 74.0368 136.574 73.648 139.579C73.2238 142.819 71.7314 153.69 71.7196 153.8Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2356 154.601L72.996 154.566C72.996 154.46 74.5002 143.588 74.9244 140.336C75.3172 137.242 76.1026 136.57 76.6957 136.016L76.8371 135.891C77.4733 135.309 81.9664 132.458 82.1549 132.336L82.2845 132.544C82.2413 132.572 77.6226 135.502 77.002 136.079L76.8567 136.209C76.248 136.747 75.5567 137.359 75.1679 140.364C74.7437 143.62 73.2513 154.491 73.2356 154.601Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7791 155.445L74.5395 155.41C74.5395 155.304 76.0437 144.433 76.4679 141.181C76.8606 138.086 77.6461 137.414 78.2353 136.861L78.3806 136.735C79.0129 136.154 83.1917 133.503 83.3685 133.393L83.4981 133.597C83.4549 133.624 79.1779 136.346 78.5416 136.912L78.3963 137.041C77.7875 137.579 77.1002 138.192 76.7075 141.196C76.2833 144.464 74.7948 155.335 74.7791 155.445Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.299 156.247L76.0555 156.211C76.0555 156.101 77.5637 145.234 77.9878 141.978C78.3806 138.887 79.1661 138.216 79.7552 137.678L79.8966 137.552C80.5328 136.967 84.696 134.331 84.8727 134.218L85.0023 134.422C84.9591 134.449 80.6821 137.171 80.0615 137.729L79.9162 137.858C79.3074 138.396 78.6201 139.009 78.2274 142.01C77.8032 145.266 76.3108 156.137 76.299 156.247Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7875 157.122L77.5479 157.091C77.5479 156.981 79.0561 146.094 79.4763 142.858C79.8691 139.763 80.6546 139.095 81.2476 138.538L81.389 138.412C82.0253 137.831 86.1373 135.223 86.3101 135.113L86.4397 135.317C86.4005 135.345 82.1745 138.023 81.554 138.593L81.4087 138.722C80.7999 139.26 80.1087 139.869 79.7198 142.873C79.2957 146.141 77.8032 157.012 77.7875 157.122Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.335 157.967L79.0954 157.931C79.0954 157.821 80.5996 146.954 81.0238 143.698C81.4165 140.607 82.202 139.936 82.7911 139.398L82.9364 139.268C83.5688 138.687 87.7594 136.032 87.9361 135.922L88.0657 136.126C88.0225 136.154 83.718 138.875 83.0975 139.449L82.9522 139.578C82.3473 140.116 81.6561 140.729 81.2633 143.73C80.8352 146.986 79.335 157.857 79.335 157.967Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3917 137.466H88.1482V154.201H88.3917V137.466Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.966 138.396H86.7225V155.131H86.966V138.396Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5639 139.178H85.3204V155.913H85.5639V139.178Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0911 140.423H83.8476V156.635H84.0911V140.423Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.6615 142.862H82.418V157.57H82.6615V142.862Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2606 151.681L80.7045 156.577L80.8255 156.788L89.3816 151.892L89.2606 151.681Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8235 155.229L80.7017 155.017L89.2518 150.108L89.3736 150.32L80.8235 155.229Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8235 153.772L80.7017 153.564L89.2518 148.655L89.3736 148.867L80.8235 153.772Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2606 147.077L81.2942 151.636L81.4152 151.847L89.3816 147.289L89.2606 147.077Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2561 145.65L81.4757 150.098L81.5965 150.31L89.377 145.861L89.2561 145.65Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2586 144.072L81.7763 148.354L81.8972 148.565L89.3795 144.283L89.2586 144.072Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1549 147.052L82.0331 146.84L89.2518 142.697L89.3736 142.909L82.1549 147.052Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.308 145.387L82.1863 145.179L89.2518 141.122L89.3736 141.334L82.308 145.387Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.308 143.879L82.1863 143.667L89.2518 139.614L89.3736 139.822L82.308 143.879Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2609 138.032L83.0467 141.588L83.1676 141.799L89.3819 138.243L89.2609 138.032Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3609 99.7854H77.8622V105.084H78.3609V99.7854Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6301 100.259L75.1404 100.331L75.9179 105.647L76.4075 105.575L75.6301 100.259Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2691 99.9187L79.5169 105.238L80.0068 105.307L80.759 99.988L80.2691 99.9187Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1096 110.02C75.977 110.02 74.3039 108.936 74.3039 107.554C74.3039 106.171 75.977 105.083 78.1096 105.083C80.2422 105.083 81.9153 106.167 81.9153 107.554C81.9153 108.94 80.2461 110.02 78.1096 110.02ZM78.1096 105.582C76.2558 105.582 74.8026 106.446 74.8026 107.546C74.8026 108.646 76.2558 109.51 78.1096 109.51C79.9633 109.51 81.4204 108.642 81.4204 107.546C81.4204 106.45 79.9673 105.582 78.1096 105.582Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1017 108.343C75.7727 108.343 73.9504 107.165 73.9504 105.649C73.9504 104.133 75.7727 102.959 78.1017 102.959C80.4307 102.959 82.2531 104.137 82.2531 105.649C82.2531 107.161 80.4307 108.343 78.1017 108.343ZM78.1017 103.501C76.0791 103.501 74.4924 104.443 74.4924 105.649C74.4924 106.855 76.0634 107.801 78.1017 107.801C80.1401 107.801 81.7111 106.855 81.7111 105.649C81.7111 104.443 80.1204 103.501 78.1017 103.501V103.501Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1017 106.733C75.6392 106.733 73.7069 105.48 73.7069 103.882C73.7069 102.283 75.6392 101.03 78.1017 101.03C80.5642 101.03 82.4966 102.283 82.4966 103.882C82.4966 105.48 80.5682 106.733 78.1017 106.733ZM78.1017 101.604C75.9612 101.604 74.2803 102.605 74.2803 103.882C74.2803 105.158 75.9612 106.16 78.1017 106.16C80.2422 106.16 81.9232 105.158 81.9232 103.882C81.9232 102.605 80.2461 101.604 78.1017 101.604Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9233 102.729L73.4329 102.82L74.317 107.585L74.8074 107.494L73.9233 102.729Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9114 107.613L81.4244 107.522C81.7818 105.61 82.3238 102.7 82.3434 102.511H82.8383C82.8383 102.641 82.3355 105.351 81.9114 107.613Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9377 109.38L75.6156 104.863L76.1105 104.828L76.4325 109.345L75.9377 109.38Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2078 104.701L79.8793 109.218L80.3728 109.254L80.7013 104.737L80.2078 104.701Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3609 105.331H77.8622V109.773H78.3609V105.331Z",
    fill: "#E2E2E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1096 105.488C75.435 105.488 73.3377 104.18 73.3377 102.511C73.3377 100.842 75.435 99.5339 78.1096 99.5339C80.7842 99.5339 82.8697 100.842 82.8697 102.507C82.8697 104.172 80.7881 105.488 78.1096 105.488ZM78.1096 100.115C75.8395 100.115 73.919 101.211 73.919 102.511C73.919 103.811 75.8395 104.907 78.1096 104.907C80.3797 104.907 82.3002 103.811 82.3002 102.511C82.3002 101.211 80.3836 100.115 78.1096 100.115V100.115Z",
    fill: "#D6403C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2613 106.482L79.2603 115.122V99.8127L64.2613 92.2288V106.482Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3384 106.91L78.3374 115.55V100.245L63.3384 91.6084V106.91Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3374 115.55L79.2603 115.122V99.7068L78.3374 100.245V115.55Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3384 91.6084L64.2613 91.0703L79.2603 99.7068L78.3374 100.245L63.3384 91.6084Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4392 102.46L64.9211 111.745V155.033H66.8888V112.648L71.6921 104.294L70.4392 102.46Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3018 102.9C70.3063 103.185 70.3776 103.466 70.5099 103.719C70.6422 103.972 70.8318 104.19 71.0637 104.357C71.4839 104.6 71.8256 104.357 71.8256 103.78C71.8211 103.494 71.7498 103.214 71.6175 102.961C71.4852 102.708 71.2955 102.489 71.0637 102.322C70.6592 102.079 70.3018 102.338 70.3018 102.9Z",
    fill: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.8534 155.033C66.8534 155.351 66.4214 155.61 65.8873 155.61C65.3531 155.61 64.9211 155.351 64.9211 155.033C64.9211 154.715 65.3531 154.452 65.8873 154.452C66.4214 154.452 66.8534 154.711 66.8534 155.033Z",
    fill: "#0F0F0F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1844_6672"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 202.328,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSportCourt);
export default __webpack_public_path__ + "static/media/MultiSportCourt.5bd198e1f190f9037ea0b49d57e17223.svg";
export { ForwardRef as ReactComponent };